export { default } from './CompanyAuthorizedSignerConfig';
